import { render, staticRenderFns } from "./recharge-record.vue?vue&type=template&id=4db85962&scoped=true&"
import script from "./recharge-record.vue?vue&type=script&lang=js&"
export * from "./recharge-record.vue?vue&type=script&lang=js&"
import style0 from "./recharge-record.vue?vue&type=style&index=0&id=4db85962&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db85962",
  null
  
)

export default component.exports